// Utils
import { removeUndefinedPropertiesFromObject } from '@sportal365/smp-widget-utils';

// Types
import { IAssets, ITennisConfig, ITennisRound } from '../../../../packages/types';

interface INormalizeTennisMatchesDataArgs {
  round?: ITennisRound;
  dataLabels?: ITennisConfig['dataLabels'] | null;
}

export interface INormalizedRoundData {
  name: string;
  id: string;
  type: string;
  assets: IAssets | null;
}

export const normalizeRoundData = ({ round, dataLabels }: INormalizeTennisMatchesDataArgs): INormalizedRoundData | undefined => {
  if (!round) return;

  return removeUndefinedPropertiesFromObject({
    id: round.id,
    name: `${dataLabels?.round ? `${dataLabels?.round} ` : ''}${round.name}`,
    type: round.entityType,
    assets: round.assets,
  });
};
